import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDrop } from 'react-dnd';
import { Button, Image } from "react-bootstrap";
import Popup from "reactjs-popup";
import { useDispatch } from "react-redux";

// Constants
import colors from "../../../utils/colors";

// Images
import verticalContainerImg from "../../../assets/images/container-v.png";
import green from "../../../assets/images/tiled-green-card.png";
import yellow from "../../../assets/images/tiled-yellow-card.png";
import blue from "../../../assets/images/tiled-blue-card.png";
import red from "../../../assets/images/tiled-red-card.png";
import items from "../../../utils/items";

import {
	openContainerProperties
} from "../../../Redux/dispatchers";
import Tooltip from "rc-tooltip";



/**
 * 
 * @param {DroppableDirectCostField.propTypes} props 
 * @returns 
 */
export default function DroppableDirectCostField(props) {
	const dispatch = useDispatch()

	const [showUnitsPopup, setShowUnitsPopup] = useState(false);
	const [soldUnites, setSoldUnites] = useState(0);
	const [item, setItem] = useState(null);

	const [{ isOver, canDrop }, drop] = useDrop({
		accept: [items.stockContainer],
		collect: (monitor) => ({
			isOver: monitor.isOver(),
			canDrop: monitor.canDrop(),
		}),
		drop: (item) => {
			setItem(item);
			setShowUnitsPopup(true);
			return item;
		},
	})

	const backgroundColor = (isOver && canDrop) ? colors.activeBackground : ""
	const canPlayerDrop = (props.canEdit) ? drop : null;

	// Restored board state can contain null entries for some fields -
	// fall back to an empty object instead of crashing the whole board.
	const data = props.data || {};

	const showContainerProperties = () => {
		if (data.hasContainer)
			dispatch(openContainerProperties("FIELD", "DirectCost", props.id));
	};

	const [isHover, setIsHover] = useState(false);

	return (
		<>
			<div className="sold-units-popup">
				{
					(showUnitsPopup) ?
						<Popup
							open
							modal
							onClose={() => setShowUnitsPopup(false)}
						>
							<>
								<div className="popup-header">
									Confirmation required!
								</div>
								<div className="popup-body">
									<div>How many units did you sell?</div>
									<input autoFocus type="text" id="units" name="units" onChange={e => setSoldUnites(parseInt(e.target.value))} />
									<Button size="sm" onClick={(e) => {
										if (soldUnites && soldUnites <= parseInt(item.cardValue)) {
											props.appendContainer(props.id, item.coins, item.hasCard, soldUnites, item.cardColor, item.cardValue, item.id, item.pinId);
											setShowUnitsPopup(false);
										}
									}}>Confirm</Button>
								</div>
							</>
						</Popup>
						:
						null
				}
			</div>
			{
				(data.hasContainer) ?
					<div className="Vertical-droppable-field" onClick={showContainerProperties}
						onMouseEnter={() => setIsHover(true)}
						onMouseLeave={() => setIsHover(false)}>
						<Tooltip placement="topLeft"
							align={{
								offset: [0, 5],
							}}
							visible={isHover}
							overlay={
								<div style={{
									zIndex: 1000,
									display: "flex",
									flexDirection: "column",
								}}>
									<span style={{ fontSize: ".6rem" }}>{props.data.coins?.reduce((acc, coin) => acc + coin, 0)} Coins</span>
								</div>
							}
						>
							<div className="containerObjClass">
								<Image className="objModelClass" src={verticalContainerImg} />
								<div className="Coins-vertical-droppable">
									{
										(props.data.coins.map((value, index) => {
											let coinClass = (props.data.coins.length === (index + 1) && (index + 1) % 5 === 0) ? "last-coin " : "not-last-coin ";
											switch (value) {
												case 10:
													coinClass += "gold";
													break
												case 1:
													coinClass += "silver";
													break
												case 0.5:
													coinClass += "bronze";
													break
												default:
													break
											}

											return (
												<div key={index} className={["coin", coinClass].join(' ')}></div>
											)
										}))
									}
									{
										(props.data.hasCard && props.data.cardType === "label") ?
											<div className="containerProductCardDraggable">
												{(
													(props.data.cardColor === "economy" &&
														<Image className="containerProductCardDraggableImg" src={green} />)
													|| (props.data.cardColor === "elite" &&
														<Image className="containerProductCardDraggableImg" src={red} />)
												)}
												{
													(props.data.cardValue > 0) ?
														<div className="containerProductCardValue">{props.data.cardValue}</div>
														:
														null
												}
											</div>
											:
											null
									}
								</div>
							</div>
						</Tooltip>
					</div>
					:
					<div className="Vertical-droppable-field" style={{ backgroundColor: backgroundColor }} ref={canPlayerDrop} onClick={showContainerProperties}></div>
			}
		</>
	);
}


DroppableDirectCostField.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	canEdit: PropTypes.bool,
	appendContainer: PropTypes.func.isRequired,
	data: PropTypes.shape({
		hasContainer: PropTypes.bool.isRequired,
		coins: PropTypes.arrayOf(PropTypes.number).isRequired,
		hasCard: PropTypes.bool,
		cardType: PropTypes.string,   // e.g., "label"
		cardColor: PropTypes.string,  // e.g., "economy" | "elite"
		cardValue: PropTypes.number,
	}).isRequired,
};